import { createContext, useContext, useState, ReactNode } from "react";
import { MenuTopLevelItem } from "./types";

// Define the context state and functions
interface OldMenuContextType {
  isOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  toggleMenu: () => void;
  activeSubmenu: MenuTopLevelItem | null;
  setActiveSubmenu: (submenu: MenuTopLevelItem | null) => void;
}

// Create context with default undefined value
const OldMenuContext = createContext<OldMenuContextType | undefined>(undefined);

// Provider props interface
interface OldMenuProviderProps {
  children: ReactNode;
}

// Provider component
export const OldMenuProvider = ({ children }: OldMenuProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState<MenuTopLevelItem | null>(
    null,
  );

  const openMenu = () => setIsOpen(true);
  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen((prev) => !prev);

  const value: OldMenuContextType = {
    isOpen,
    openMenu,
    closeMenu,
    toggleMenu,
    activeSubmenu,
    setActiveSubmenu,
  };

  return (
    <OldMenuContext.Provider value={value}>{children}</OldMenuContext.Provider>
  );
};

// Custom hook to use the context
export const useOldMenu = (): OldMenuContextType => {
  const context = useContext(OldMenuContext);
  if (context === undefined) {
    throw new Error("useOldMenu must be used within an OldMenuProvider");
  }
  return context;
};

export default OldMenuContext;
